"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabletAndDesktopOnly = exports.mobileAndTabletOnly = exports.desktopOnly = exports.tabletOnly = exports.mobileOnly = void 0;
function mobileOnly(style) {
    return "\n    @media screen and (max-width: 768px) {\n      ".concat(style, "\n    }\n  ");
}
exports.mobileOnly = mobileOnly;
function tabletOnly(style) {
    return "\n    @media screen and (min-width: 769px) and (max-width: 1279px) {\n      ".concat(style, "\n    }\n  ");
}
exports.tabletOnly = tabletOnly;
function desktopOnly(style) {
    return "\n    @media screen and (min-width: 1280px) {\n      ".concat(style, "\n    }\n  ");
}
exports.desktopOnly = desktopOnly;
function mobileAndTabletOnly(style) {
    return "\n    @media screen and (max-width: 1279px) {\n      ".concat(style, "\n    }\n  ");
}
exports.mobileAndTabletOnly = mobileAndTabletOnly;
function tabletAndDesktopOnly(style) {
    return "\n    @media screen and (min-width: 769px) {\n      ".concat(style, "\n    }\n  ");
}
exports.tabletAndDesktopOnly = tabletAndDesktopOnly;
